// tslint:disable
export const dicoGOPVO = {
    id: "1",
    cover: {
        image: "pvo",
        title: "Prima Volontés Obsèques +",
        target: "Particuliers âgés de 18 ans à 85 ans<sup>(1)</sup>.",
        topic:
            "Contrat de prestation de services garantissant à l’assuré l’organisation de ses obsèques par le prestataire « Le Choix Funéraire ».\n" +
            "Le contrat est financé par « Prima Capital Obsèques+ » en prime unique ou en primes temporaires.",
        tag: "Obsèques",
        age: "18 / 85 ans",
    },
    conditions: [
        "Adhésion possible jusqu’à 85 ans<sup>(1)</sup> sans formalité médicale.",
        "Souscription éligible en France métropolitaine et DROM.",
        "L’adhésion peut le cas échéant être réalisée à distance.",
    ],
    plus: [
        { icon: "currency", text: "Le choix entre 3 formules : 3 400 €, 4 100 € et 5 900 €." },
        {
            icon: "edit",
            text: "Possibilité de modifier à tout moment : le contenu des prestations, le mandataire désigné pour veiller à la bonne exécution de ses volontés, l’opérateur funéraire désigné pour exécuter les obsèques.",
        },
        {
            icon: "account",
            text: `Des services d’assistance complets : assistant conseil, avant et après le décès : Assistance téléphonique par une cellule d'expert au 0 969 320 522 (Tarif selon opérateur – Appel non surtaxé du lundi-Vendredi, 08h00-12h30 et 13h30-18h00). <br/> 
            Au moment du décès (pour les proches du défunt) : Permanence téléphonique 24h/24h, 7j/7j au numéro 0 805 801 771 (appel depuis un poste fixe). Un conseiller funéraire est mis à disposition dans les 2 heures suivant l'appel.
            `,
        },
    ],

    /* DOCUMENTS ANNEXES */

    docs: {
        adhesion: [
            {
                label: "Dispositions générales et descriptif des prestations",
                url: require("./documents/adhesion/dispositions_generales_et_descriptif_des_prestations_PVO_plus.pdf"),
                required: true,
            },
            {
                label: "Annexe désignation de bénéficiaire(s) : clauses libres",
                url: require("./documents/adhesion/annexe_designation_clause_beneficiaire.pdf"),
                required: false,
            },
            {
                label: "Document d'information",
                url: require("./documents/adhesion/document_information.pdf"),
                required: true,
            },
        ],
        common: [
            {
                label: "Plaquette commerciale",
                url: require("./documents/common/plaquette_commerciale_obseques.pdf"),
                required: false,
            },
            {
                label: "Convention d'assistance",
                url: require("./documents/common/convention_assistance_obseques.pdf"),
                required: false,
            },
            {
                label: "Guide des démarches obsèques",
                url: require("./documents/common/guide_des_demarches_obseques.pdf"),
                required: false,
            },
            {
                label: "Attestation de mise à disposition des documents clés",
                url: require("./documents/common/documents_cles_PCO.pdf"),
                required: true,
            },
            { label: "Fiche IPID", url: require("./documents/common/fiche_IPID_pvo+.pdf"), required: true },
            {
                label: "Dossier d’Entrée en Relation (DER)",
                url: require("./documents/common/DER_dossier_entree_en_relation.pdf"),
                required: true,
            },
        ],
    },

    /********************/

    summary: {
        image: "pvo",
        paragraphs: [
            {
                headline: "Niveaux de garanties",
                text: "3 formules pour une prise en charge totale des obsèques : Organisation, Présentation du défunt, Cérémonie, Convoi, Fourniture du cercueil (différent selon la formule) et de l’urne cinéraire le cas échéant.",
            },
            {
                headline: "Délai de carence",
                text: "Six mois sauf en cas de décès accidentel.",
            },
            {
                headline: "Capital garanti",
                text: "Le capital garanti en cas de décès au titre du contrat d’assurance PCO+ de La Mondiale correspond au minimum au montant total du devis des prestations choisi à la date de souscription",
            },
        ],
    },
    details: {
        paragraphs: [
            {
                headline: "Services",
                text:
                    "<ul><li>Assistant conseil (démarches administratives).</li><li>Faire-part et cartes de remerciement.</li><li>Assistance téléphonique par une cellule d'expert au 0 969 320 522 (Tarif selon opérateur – Appel non surtaxé du lundi-Vendredi, 08h00-12h30 et 13h30-18h00).</li> Au moment du décès (pour les proches du défunt) : Permanence téléphonique 24h/24h, 7j/7j au numéro 0 805 801 771 (appel depuis un poste fixe). Un conseiller funéraire est mis à disposition dans les 2 heures suivant l'appel." + 
                    "<li>Remise d’un guide conseil au décès.</li><li>Prise en charge des taxes liées aux obsèques.</li></ul>",
            },
            {
                headline: "Exécution des prestations",
                text:
                    "Au décès de l’assuré :<ul><li>« Le Choix Funéraire » met à disposition des proches (bénéficiaires) un numéro vert spécifique : 0 805 801 771.</li>" +
                    "<li>« Le Choix Funéraire » s’assure du bon déroulement de vos obsèques, conformément au contenu détaillé de la formule « Prima Volontés Obsèques+ » choisie lors de l’adhésion.</li></ul>",
            },
            {
                headline: "Financement des prestations",
                text: "L’exécution des prestations est conditionnée à l’adhésion par l’Assuré au contrat d’assurance PCO+ auprès de La Mondiale et «Le Choix Funéraire» comme bénéficiaire du contrat.",
            },
            {
                headline: "Process d’Adhésion en agence",
                text: "<ul><li>Le client choisit parmi les 3 formules celle qui correspond à ses souhaits.</li><li>Il remplit et signe sa demande de souscription au contrat civil PVO+ en indiquant la formule choisie.</li><li>Remplir et faire signer la proposition d’adhésion PCO+.</li><li>Remplir et faire signer la fiche d’Identification personne physique.</li><li>Adresser au centre de gestion : les 2 propositions d’adhésion (PCO+ et PVO+), une photocopie recto/ verso de la pièce d’identité + un justificatif de domicile de moins de 3 mois + RIB.</li></ul>",
            },
            {
                headline: "Contacts",
                text:
                    "<b><ul><li>Adresse postale « Centre de gestion » de Mons-en-Barœul :</b></li></ul>AG2R LA MONDIALE - <br/>Logistique Entrante Groupe – Obsèques<br />32 avenue Emile Zola<br />Mons-en-Barœul - 59896 Lille Cedex 9<br />" +
                    "<br/><b><ul><li>Adresse mail « Centre de gestion » de Mons-en-Barœul :</b></li></ul>Adresse contrat/client :<br />LM EXPERT - (MAILDSC@ag2rlamondiale.fr)<br /><br />Adresse gestion :<br />BG GESTION OBSEQUES - (BG_GESTION_OBSEQUES@ag2rlamondiale.fr)<br /><br />Adresse pôle décès :<br />BG PÔLE DECES (succession@ag2rlamondiale.fr)",
            },
        ],
        mentions: [
            "<sup>(1)</sup> L’âge limite d’adhésion varie en fonction de la périodicité de la prime. L’âge limite d’adhésion en prime unique est de 69 ans inclus. (Cf. Notice d’information)",
        ],
    },
    benchmark: {
        title: "Prima Volontés Obsèques +",
        head: [
            { headline: "" },
            { headline: "ag2r La Mondiale", subheading: "Prima Volontés Obsèques + (formule initiale)" },
            { headline: "MACIF", subheading: "Garanties Obsèques (formule sérénité" },
            { headline: "BNP PARIBAS", subheading: "BNP Paribas Obsèques" },
            { headline: "SOCIETE GENERALE", subheading: "Garantie Obsèques (prestations)" },
        ],
        body: [
            {
                cells: [
                    "Type de prime / Âge limite périodicité",
                    "• Prime temporaire : 80 ans<br>• Prime unique : 69 ans",
                    "• Prime viagère : 79 ans<br>• Prime temporaire : 75 ans",
                    "• Prime viagère : 85 ans<br>• Prime temporaire : 85 ans",
                    "• Prime viagère : 80 ans<br>• Prime temporaire : 80 ans<br>• Prime unique : 70 ans",
                ],
            },
            {
                cells: ["Délai de carence", "6 mois", "12 mois", "12 mois", "12 mois"],
            },
            {
                highlight: true,
                cells: [
                    "Tarifs mensuels (60 ans)",
                    "<u><i>Formule à 3 400 €</i></u><br>• Prime temporaire (10 ans) : 36,80 €<br>• Prime unique : 3 519,68 €",
                    "<u><i>Formule à 3 600 €</i></u><br>• Prime viagère : 19,92 €<br>• Prime temporaire (10 ans) : 43,11 €",
                    "<u><i>Formule à 4 000 €</i></u><br>• Prime temporaire (10 ans) : 38,15 €<br>• Prime unique : 3913,11 €",
                    "<u><i>Formule à 3 500 €</i></u><br>• Prime viagère : 18,08 €<br>• Prime temporaire (10 ans) : 33,42 €<br>• Prime unique : 2882,96 €",
                ],
            },
            {
                highlight: true,
                cells: [
                    "Tarifs mensuels (70 ans)",
                    "<u><i>Formule à 3 400 €</i></u><br>• Prime temporaire (10 ans) : 40,55 €<br>• Prime unique : /",
                    "<u><i>Formule à 3 600 €</i></u><br>• Prime viagère : 30,15 €<br>• Prime temporaire (10 ans) : 46,98 €",
                    "<u><i>Formule à 4 000 €</i></u><br>• Prime temporaire (10 ans) : 47,71 €<br>• Prime unique : 3 931,19 €",
                    "<u><i>Formule à 3 500 €</i></u><br>• Prime viagère : 27,90 €<br>• Prime temporaire (10 ans) : 40,69 €<br>• Prime unique : 3264,93 €",
                ],
            },
        ],
    },
};



// WEBPACK FOOTER //
// ./src/data/products/go/dicoPVO.ts